import { connect } from 'react-redux';

import { INeighbourhoodDispatchProps, INeighbourhoodProps, NeighbourhoodGallery } from './index';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export function mapStateToProps(state: IState): INeighbourhoodProps {
  return {
    neighbourhoodList: state.villageData.village.neighbourhoodList ?? [],
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): INeighbourhoodDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Neighbourhood)),
  };
}

export const NeighbourhoodContainer = connect<INeighbourhoodProps, INeighbourhoodDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(NeighbourhoodGallery);
